import React, { useEffect, useState } from "react";
import newyear from '../../../../assets/images/News/newyear.jpeg'
import certificate from '../../../../assets/images/News/certificate.jpeg'
import { gethomefooter } from "../../../../Services/service";

function Footer() {
  const [homefooterinfo , setHomefooterinfo]=useState()
  useEffect(()=>{
    loadData();
  },[]);
async function loadData(){
const fn=await gethomefooter();
setHomefooterinfo(fn);
}
  return (
    <>
      <footer className="binduz-er-footer-area">
        {homefooterinfo && homefooterinfo.homefooterinfo.map((item)=>{
          return(
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="binduz-er-footer-widget-style-1">
                    <div className="binduz-er-footer-title">
                      <h3 className="binduz-er-title">{item.categories}</h3>
                    </div>
                    <div className="binduz-er-footer-menu-list">
                      <ul>
                        <li>
                          <a href="/News-details/1298">{item.arch}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.newl}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.gadgets}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.dev}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.recip}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.deco}</a>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <a href="/News-details/1298">{item.inter}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.sfashion}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.sfashion}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.lstyle}</a>
                        </li>
                        <li>
                          <a href="/News-details/1298">{item.lback}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="binduz-er-footer-widget-style-1">
                    <div className="binduz-er-footer-title">
                      <h3 className="binduz-er-title">{item.nletter}</h3>
                    </div>
                    <div className="binduz-er-footer-widget-form">
                      <form action="#">
                        <div className="binduz-er-input-box">
                          <i className="fal fa-user"></i>
                          <input type="text" placeholder="Enter your name" />
                        </div>
                        <div className="binduz-er-input-box">
                          <i className="fal fa-envelope"></i>
                          <input
                            type="email"
                            placeholder="Enter email address"
                          />
                        </div>
                        <div className="binduz-er-input-box">
                          <button type="button">
                            <i className="fal fa-paper-plane"></i> {item.subscribe}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="binduz-er-footer-widget-style-3">
                    <div className="binduz-er-footer-title">
                      <h3 className="binduz-er-title">{item.rfeed}</h3>
                    </div>
                    <div className="binduz-er-footer-widget-feeds">
                      <div className="binduz-er-sidebar-latest-post-box">
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            {/* <img
                              src={
                                require(`../../../../assets/images/latest-post-1.jpg`)
                                  .default
                              }
                              alt="latest"
                            /> */}
                            <img 
                            width={200}
                            src={newyear} alt="" />
                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> {item.date1}
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                              {item.p1}
                              </a>
                            </h4>
                          </div>
                        </div>
                        <div className="binduz-er-sidebar-latest-post-item">
                          <div className="binduz-er-thumb">
                            {/* <img
                              src={
                                require(`../../../../assets/images/latest-post-2.jpg`)
                                  .default
                              }
                              alt="latest"
                            /> */}
                            <img 
                            width={200}
                            src={certificate} alt="" />

                          </div>
                          <div className="binduz-er-content">
                            <span>
                              <i className="fal fa-calendar-alt"></i> {item.date2}
                            </span>
                            <h4 className="binduz-er-title">
                              <a href="#">
                                {item.p2}
                              </a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="binduz-er-footer-widget-info">
                <div className="binduz-er-logo">
                  <a href="/">
                    <img
                      src={
                        require("../../../../assets/images/logo-2.png").default
                      }
                      alt=""
                    />
                  </a>
                </div>
                <div className="binduz-er-text">
                  <p>
                  {item.p3}
                  </p>
                </div>
                <div className="binduz-er-social">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-behance"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        )})}
        <div className="binduz-er-back-to-top">
          <p>
            BACK TO TOP <i className="fal fa-long-arrow-right"></i>
          </p>
        </div>
      </footer>
      <div className="binduz-er-footer-copyright-area">
       {homefooterinfo && homefooterinfo.companyinfo.map((item)=>{
        return(
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="binduz-er-copyright-text">
                <p>
                  {item.c1}<span>{item.c2}</span> {item.year}
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="binduz-er-copyright-menu float-lg-end float-none">
                <ul>
                  <li>
                    <a href="/about">{item.c3}</a>
                  </li>
                  <li>
                    <a href="/about">{item.c4}</a>
                  </li>
                  <li>
                    <a href="/contact">{item.c5}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
          )})}
      </div>
    </>
  );
}

export default Footer;
